<template>
  <div>
    <core-modal-header v-if="isMulti">Delete <span class="font-semibold">{{count}} Selected</span> Tags?</core-modal-header>
    <core-modal-header v-else>Delete Tag <span class="font-semibold">{{tagName}}</span>?</core-modal-header>

    <core-modal-body>
      <u-alert
        :icon="COMMON_ICONS.alert"
        color="red"
        title="This action cannot be undone."
        :description="description"
      />
    </core-modal-body>

    <core-modal-footer>
      <u-button color="charcoal" variant="soft" size="xl" @click="modal.close()">Cancel</u-button>
      <u-button @click="confirm" size="xl" color="red" :loading="isSaving">Delete {{isMulti ? 'Tags' : 'Tag'}}</u-button>
    </core-modal-footer>

  </div>
</template>

<script setup>
  const emit = defineEmits(['success']);
  const props = defineProps({
    tags: Array,
    modal: Object
  });

  const count = props.tags.length;
  const isMulti = count > 1;
  const tagName = html2text(props.tags[0].name);
  const isSaving = ref(false);
  const description = isMulti
    ? 'Deleting the selected tags will remove them from all files and break the associated share link and/or QR code, but your files will remain safely in your FOREVER Account.'
    : 'Deleting this tag will remove it from all files and break the associated share link and/or QR code, but your files will remain safely in your FOREVER Account.';

  async function confirm() {
    try {
      isSaving.value = true;
      await useTagsStore().destroyTags({ids: props.tags.map(a => a.id)});
      emit('success');
    } catch (e) {
      useErrorToast().add();
    } finally {
      isSaving.value = false;
    }
  }
</script>
